








































































































































import { Component, Vue } from "vue-property-decorator";
import { Pagination } from "vant";
Vue.use(Pagination);
@Component({
  components: {},
})
export default class Home extends Vue {
  public active = 0;
  public currentPage = 1;
  public handleSwiperItem(e) {
    this.currentPage = e + 1;
  }
  public handlePaginChange(e) {
    this.active = e - 1;
  }
}
